/* unplugin-vue-components disabled */import script from "./YoY.vue?vue&type=script&setup=true&lang=js"
export * from "./YoY.vue?vue&type=script&setup=true&lang=js"

import "./YoY.vue?vue&type=style&index=0&id=0782bdea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0782bdea"]])

export default __exports__